module.exports = __webpack_public_path__ + "img/diploma_2.843a51f9.jpg";